import { FormattedMessage } from "react-intl";
import React from "react";

import { LottieIconNames } from "src/shared/config";
import { RoutePaths } from "src/app/model";

export const products: {
  icon: LottieIconNames;
  content: React.ReactNode;
  title: React.ReactNode;
  path: RoutePaths;
}[] = [
  {
    icon: LottieIconNames.SICHERO,
    content: (
      <FormattedMessage
        id="productCard.about.sichero"
        defaultMessage="SICHERO is a smart vision assistant that helps the elderly live independently and safely in their own flats. It is a mini-computer equipped with cameras and artificial intelligence that monitors users’ activity, predicts falls, and sends an SOS to a nurse if needed. It's non-invasive, using only camera sensors without saving any user data. With SICHERO, the elderly can live safely in their own flats, save on nursing costs, and gain independence. Additionally, our preventive algorithms use machine learning techniques to prevent upcoming diseases."
      />
    ),
    title: <FormattedMessage id="global.sichero" defaultMessage="SICHERO" />,
    path: RoutePaths.SICHERO,
  },
  {
    icon: LottieIconNames.SEARCH_AGENT,
    content: (
      <FormattedMessage
        id="productCard.about.searchAgent"
        defaultMessage="An advanced search engine designed to enhance the shopping experience, especially when the user is unsure of the exact name of the product they’re looking for. By simply describing the product, our search engine utilizes modern Large Language Models (LLMs) and Retrieval-Augmented Generation (RAG) methods, to accurately identify and present the desired product to you. This integration of cutting-edge search agent ensures effective optimization of your product discovery, making shopping efficient and satisfying."
      />
    ),
    title: (
      <FormattedMessage
        id="global.searchAgent"
        defaultMessage="Search agent"
        values={{ nl: "" }}
      />
    ),
    path: RoutePaths.SEARCH_AGENT,
  },
  {
    icon: LottieIconNames.DYNAMIC_PRICING,
    content: (
      <FormattedMessage
        id="productCard.about.dynamicPricing"
        defaultMessage="A sophisticated toolkit for optimizing the pricing of outdoor advertisements. It analyzes pricing data patterns to determine the most optimal pricing strategy, resulting in your increased revenue. The toolkit allows you to identify high-potential, previously undiscovered locations for new outdoor banners. Additionally, it pinpoints existing banners that are not cost-effective, preventing financial losses for your company. Thus, our toolkit contributes to both enhanced pricing and placement of your ads."
      />
    ),
    title: (
      <FormattedMessage
        id="global.dynamicPricing"
        defaultMessage="Dynamic pricing"
        values={{ nl: "" }}
      />
    ),
    path: RoutePaths.DYNAMIC_PRICING,
  },
  {
    icon: LottieIconNames.SCRAPER_AGENT,
    content: (
      <FormattedMessage
        id="productCard.about.scraperAgent"
        defaultMessage="An advanced web scraper, based on Large Language Models (LLMs) and Retrieval-Augmented Generation (RAG) technology, efficiently collects desired product information, analyzes relevant web pages, and finds relevant services from internet data, optimized for rapid retrieval and analysis. The scraper also summarizes key web events — ranging from local happenings to weather updates. This efficient representation is tailor-made for further AI-driven analytics, enabling deep insights and facilitating strategic decisions."
      />
    ),
    title: (
      <FormattedMessage
        id="global.scraperAgent"
        defaultMessage="Scraper agent"
        values={{ nl: "" }}
      />
    ),
    path: RoutePaths.SALES_AGENT,
  },
];
